import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  buttonRed: {
    textTransform: 'capitalize',
    color: '#fff',
    background: '#ba3636',
    '&:hover': {
      background: '#813232',
    },
  },
  butttonGreen: {
    textTransform: 'capitalize',
    color: 'primary',
  },
  fullWidth: {
    width: '100%',
  },
}))

export default useStyles
